import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';

import jwtDecode from 'jwt-decode';
import { Logger } from 'utils/Logger';
import { onLoginSuccess } from 'reducers/auth/sagas';

import { signup } from './types';
import { requestSignupSuccess, requestSignupFailure } from './actions';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';
import normalizerError from 'utils/ErrorNormalizer';

const logger = new Logger('Saga:Signup');

export function* requestSignupSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');
  const { version, ...values } = action.payload;

  const url =
    version === 'v2'
      ? `${window._env_.PLATFORM_API_DOMAIN}/v2/auth/sign-up`
      : routerService.generate('api.platform.alpha_auth_signup');

  try {
    const response = yield call(
      authApiService.post,
      url,
      values,
    );

    const token = yield call(jwtDecode, response.data.access_token);

    yield call(
      onLoginSuccess,
      {
        accessToken: response.data.access_token,
        expiresAt: token.expires_in,
        tokenPayload: token,
      },
      true,
    );
    yield put(requestSignupSuccess());
  } catch (error) {
    if (values.type === 'BUSINESS') {
      Analytics.track(AnalyticsEventCategory.business, AnalyticsEventAction.signupError, {
        extraParams: {
          signupType: 'business',
          userType: 'business',
          error: error?.response.data,
        },
      });
    }
    logger.error('Failed to signup from network:', error);
    yield put(requestSignupFailure(normalizerError(error?.response.data)));
  }
}

export default function* signupSaga() {
  return yield all([takeLatest(signup.request, requestSignupSaga)]);
}
